import { useEffect, useState } from "react";
import MyDiv from "./attendanceCard.style";
import { Box, Flex, Text, Divider, Button, Popover, PopoverTrigger, PopoverContent, PopoverBody, Center, Spinner } from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, } from "recharts";
import { CustomToast } from "../../../../components";
import { useFetch } from "../../../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import * as routesNames from "../../../../constants/routes";

const AttendanceCard = ({ branch }: { branch: number[] }) => {

  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [chartData, setChartData] = useState<any[]>([]);

  const getFormattedDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const loadAttendanceBranchWise = async () => {
    const formattedDate = selectedDate ? getFormattedDate(selectedDate) : "";
    const params = new URLSearchParams();
    params.append("date", formattedDate);
    if (branch.length > 0) {
      branch.forEach((b) => params.append("branch", b.toString()));
    } else {
      params.append("branch", "0"); // all branches
    }
    const response = await fetchApi("Dashboard/branchWiseAttendance", "GET", "", params.toString(), "");
    if (response) {
      setChartData(response);
    }
  };


  useEffect(() => {
    loadAttendanceBranchWise();
  }, [branch, selectedDate])

  const CustomTooltip = ({ active, payload, label, navigate }: any) => {

    const branchId = payload[0]?.payload?.branch_Id;
    const branchName = payload[0]?.payload?.branch;
    const handleNavigate = (e: React.MouseEvent) => {
      e.stopPropagation();
      navigate(routesNames.ATTENDANCESHEET, {state: { branchId ,branchName ,selectedDate: selectedDate},});
    };

    if (active && payload && payload.length) {
      const order = ["On Time", "Late Attendance", "Remote", "Not Present"];
      const sortedPayload = [...payload].sort(
        (a, b) => order.indexOf(a.name) - order.indexOf(b.name)
      );

      return (
        <Box className="tooltip" onClick={handleNavigate} zIndex={1} pointerEvents="auto" cursor="pointer">
          <Box className="text" display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Text className="font-poppins text_semibold text_lg">{label}</Text>
          </Box>
          <Box p={3}>
            {sortedPayload.map((item: any) => (
              <Flex key={item.dataKey} align="center" mb={1}>
                <Box w="15px" h="15px" borderRadius="full" bg={item.fill} mr={2} />
                <Text className="font-poppins text_medium text_md">
                  {item.value} <Text as={"span"} color="grey">{item.name}</Text>
                </Text>
              </Flex>
            ))}
          </Box>
        </Box>
      );
    }
    return null;
  };

  return (
    <MyDiv>
      <Box className="card-wrapper common_bg" >
        <Box className="card" p={4} >
          <Flex justify="space-between" align="center" mb={2}>
            <Text className="font-poppins text_md text_semibold">Attendance</Text>
            <Popover isOpen={open} placement="bottom-end">
              <PopoverTrigger>
                <Button leftIcon={<CalendarIcon />} padding={3} variant="outline" onClick={() => setOpen(!open)} >
                  <Text className="font-poppins text_sm text_regular">
                    {selectedDate.toDateString()}
                  </Text>
                </Button>
              </PopoverTrigger>
              <PopoverContent w="auto">
                <PopoverBody p={2} display="flex" justifyContent="center">
                  <Calendar
                    value={selectedDate}
                    onChange={(value) => {
                      if (value instanceof Date) {
                        setSelectedDate(value);
                        setOpen(false);
                      }
                    }}
                    maxDate={new Date()}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Flex>

          <Divider my={2} />
          {loading ? (
            <Center h="200px">
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>
          ) : chartData.length === 0 ? (
            <Center h="300px">
              <Text className="font-poppins text_md text_semibold" color="gray.500">
                No data available
              </Text>
            </Center>
          ) : (
            <Box h="200px">
              <ResponsiveContainer>
                <BarChart data={chartData} barSize={40}>
                  <XAxis dataKey="branch" type="category" className="font-poppins text_xsm text_regular" />
                  <YAxis className="font-poppins text_xsm text_regular" />
                  <Tooltip content={<CustomTooltip navigate={navigate} />} />
                  <Bar dataKey="absent" stackId="a" fill="#808080" name="Not Present" />
                  <Bar dataKey="late" stackId="a" fill="#FF0000" name="Late Attendance" />
                  <Bar dataKey="remote" stackId="a" fill="hsla(55, 97%, 53%, 1.00)" name="Remote" />
                  <Bar dataKey="present" stackId="a" fill="#008000" name="On Time" radius={[20, 20, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          )}
        </Box>
      </Box>
    </MyDiv>
  );
};

export default AttendanceCard;
